import { CampaignCountdown } from '../../components/countdown'
import { CHRISTMAS_CAMPAIGN_END } from '../consts'
import { ChristmasPromotionButton } from './button'

export const ChristmasOfferPromotion = () => (
  <>
    <ChristmasPromotionButton />
    <CampaignCountdown
      end={CHRISTMAS_CAMPAIGN_END}
      className="bg-danger-default"
    />
  </>
)
